import { styled as styledMui, Box } from "@mui/material";

export const OptionCard = styledMui(Box)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    padding: "20px",
    height: "100%",
    minHeight: "180px",
    borderRadius: "12px",
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    transition: "border-color 0.15s ease, background-color 0.15s ease",
    "&:hover": disabled
      ? {}
      : {
          borderColor: theme.palette.primary.main,
          backgroundColor: theme.palette.action.hover,
        },
  }),
);

export const OptionIconWrapper = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.primary.main,
}));
